/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectIntegrationRuntimeStatus } from './ProjectIntegrationRuntimeStatus';
import {
    ProjectIntegrationRuntimeStatusFromJSON,
    ProjectIntegrationRuntimeStatusFromJSONTyped,
    ProjectIntegrationRuntimeStatusToJSON,
    ProjectIntegrationRuntimeStatusToJSONTyped,
} from './ProjectIntegrationRuntimeStatus';
import type { ProjectRuntimeStatus } from './ProjectRuntimeStatus';
import {
    ProjectRuntimeStatusFromJSON,
    ProjectRuntimeStatusFromJSONTyped,
    ProjectRuntimeStatusToJSON,
    ProjectRuntimeStatusToJSONTyped,
} from './ProjectRuntimeStatus';
import type { ProjectData } from './ProjectData';
import {
    ProjectDataFromJSON,
    ProjectDataFromJSONTyped,
    ProjectDataToJSON,
    ProjectDataToJSONTyped,
} from './ProjectData';

/**
 * 
 * @export
 * @interface ProjectWithRuntimeStatus
 */
export interface ProjectWithRuntimeStatus {
    /**
     * 
     * @type {ProjectData}
     * @memberof ProjectWithRuntimeStatus
     */
    projectData?: ProjectData;
    /**
     * 
     * @type {ProjectRuntimeStatus}
     * @memberof ProjectWithRuntimeStatus
     */
    projectRuntime?: ProjectRuntimeStatus;
    /**
     * 
     * @type {Array<ProjectIntegrationRuntimeStatus>}
     * @memberof ProjectWithRuntimeStatus
     */
    integrations?: Array<ProjectIntegrationRuntimeStatus>;
}

/**
 * Check if a given object implements the ProjectWithRuntimeStatus interface.
 */
export function instanceOfProjectWithRuntimeStatus(value: object): value is ProjectWithRuntimeStatus {
    return true;
}

export function ProjectWithRuntimeStatusFromJSON(json: any): ProjectWithRuntimeStatus {
    return ProjectWithRuntimeStatusFromJSONTyped(json, false);
}

export function ProjectWithRuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectWithRuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'projectData': json['projectData'] == null ? undefined : ProjectDataFromJSON(json['projectData']),
        'projectRuntime': json['projectRuntime'] == null ? undefined : ProjectRuntimeStatusFromJSON(json['projectRuntime']),
        'integrations': json['integrations'] == null ? undefined : ((json['integrations'] as Array<any>).map(ProjectIntegrationRuntimeStatusFromJSON)),
    };
}

export function ProjectWithRuntimeStatusToJSON(json: any): ProjectWithRuntimeStatus {
    return ProjectWithRuntimeStatusToJSONTyped(json, false);
}

export function ProjectWithRuntimeStatusToJSONTyped(value?: ProjectWithRuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectData': ProjectDataToJSON(value['projectData']),
        'projectRuntime': ProjectRuntimeStatusToJSON(value['projectRuntime']),
        'integrations': value['integrations'] == null ? undefined : ((value['integrations'] as Array<any>).map(ProjectIntegrationRuntimeStatusToJSON)),
    };
}

